import { Component, Inject } from '@angular/core';

import { Platform, NavController, LoadingController, ActionSheetController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from './app.config';
import { MyEvent } from 'src/services/myevent.services';
import { Constants } from 'src/models/contants.models';
import { AngularFireAuth } from '@angular/fire/auth';
import { NavigationExtras, Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { ConferenceStatus, ConnectionStatus, VideoConference } from 'src/models/video-conference';
import { map } from 'rxjs/operators';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  rtlSide = 'left';

  constructor(
    @Inject(APP_CONFIG) public config: AppConfig,
    private platform: Platform, private navCtrl: NavController,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private afAuth: AngularFireAuth,
    private router: Router,
    private translate: TranslateService, private myEvent: MyEvent,
    private firestore: AngularFirestore,
    private actionSheetCtrl: ActionSheetController,
    private backgroundMode: BackgroundMode,
    private localNotifications: LocalNotifications
    ) {
    this.initializeApp();
    this.myEvent.getLanguageObservable().subscribe(value => {
      this.navCtrl.navigateRoot(['./']);
      this.globalize(value);
    });
    this.userConv();
  }


  single_notification() {
    // Schedule a single notification
    this.localNotifications.schedule({
      id: 1,
      text: 'Single ILocalNotification',
      sound: 'file://sound.mp3',
      data: { secret: 'key_data' }
    });
  }


  userConv() {
    this.afAuth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          if (idTokenResult.claims.subscriber) {


            this.firestore.collection<VideoConference>('videoConference', ref => ref
            .where('connectionStatus', '==', ConnectionStatus.started)
            .where('subscriberHere', '==', false)
            .where('status', '==', ConferenceStatus.confirmed)
            .where('payStatus', '==', true)
            .where('subscriberId', '==', user.uid)
            .limit(1)
            ).snapshotChanges()
            .pipe(map(docs => {
              const conferecence = docs[0];
              if (conferecence) {
                const data = conferecence.payload.doc.data() as VideoConference;
                if (data.connectionStatus === ConnectionStatus.started) {

                  const id = conferecence.payload.doc.id;
                  return { id, ...data };
                }

              } else {
                return null;
              }
            })).subscribe(async res => {
              if (res !== null) {
                this.single_notification();
                const actionSheet = await this.actionSheetCtrl.create({
                  header: this.translate.instant('call_actions'),
                  buttons: [
                    {
                      text: this.translate.instant('answer_the_call'), icon: 'call-outline',
                      handler: () => {
                        this.goToCall(res.id);
                      },
                    },
                    {
                      text: this.translate.instant('give_up'), icon: 'close', role: 'cancel'
                    }
                  ]
                });
                // tslint:disable-next-line:no-shadowed-variable
                actionSheet.onWillDismiss().then(res => {
                  // this.detailBox = false;
                  console.log(res);
                });

                await actionSheet.present();
              }


            });
          }
        });
      }
    }).then();
  }

  goToCall(id: any) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
          videoConferenceRef: id
      }
  };
    this.router.navigate(['video-chat'], navigationExtras).then();
  }

  initializeApp() {
    this.backgroundMode.enable();
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      let defaultLang = window.localStorage.getItem(Constants.KEY_DEFAULT_LANGUAGE);
      console.log(defaultLang);
      if (defaultLang == null) {
        defaultLang = 'tr';
      }
      this.globalize(defaultLang);
     // this.checkAuthStatus();


    });
  }

  globalize(languagePriority) {
    this.translate.setDefaultLang('tr');
    const defaultLangCode = this.config.availableLanguages[0].code;
    this.translate.use(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
    this.setDirectionAccordingly(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
  }

  setDirectionAccordingly(lang: string) {
    switch (lang) {
      case 'ar': {
        this.rtlSide = 'rtl';
        break;
      }
      default: {
        this.rtlSide = 'ltr';
        break;
      }
    }
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit() {

  }

  checkAuthStatus() {
    this.afAuth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          if (idTokenResult.claims.expert) {
            this.router.navigate(['/expert']).then();
        } else if (idTokenResult.claims.admin) {
            this.router.navigate(['/admin']).then();
        } else if (idTokenResult.claims.subscriber) {
            this.router.navigate(['/subscriber']).then();
        } else {
          this.router.navigate(['/subscriber']).then();
          }
        });
      } else {
        this.router.navigate(['/subscriber']).then();
      }
    }).then(() => {
    }).catch(() => {
      console.log('not found');
    });
  }

}
